import { Component, Input, OnInit } from '@angular/core';
import { FormatOutputOptionsValue, ValueOrderByOption, ReportDetail } from '../report.manager.model';
import * as _ from 'lodash';
import { ReportManagerService } from '../report.manager.service';

const letterPaperSizeIndex = 0;
const siteNameOrderById = -4;

@Component({
    selector: 'format-output-panel-tax-savings',
    template: `
        <div class="panel-flat-body format-psr">
            <div class="row">
                <div class="col col-lg-6 psr-output-col1">
                    <div style="width: 56%; margin: 0 auto;">
                        <div class="mb-4 form-group">
                            <label>Paper Size:</label>
                            <select
                                [(ngModel)]="report.criteria.paperSize"
                                class="form-select form-select-sm intput-sm"
                            >
                                @for (option of paperSizeOptions; track option; let i = $index) {
                                    <option [ngValue]="i">{{ option }}</option>
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-6 psr-output-col2">
                    <div style="width: 93%; margin: 0 auto;">
                        <div class="mb-4 form-group">
                            <label>Order By:</label>
                            <select
                                [(ngModel)]="report.criteria.valueOrderBy"
                                class="form-select form-select-sm intput-sm"
                            >
                                @for (option of valueOrderByOptions; track option.id) {
                                    <option [ngValue]="option.id">{{ option.name }}</option>
                                }
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class FormatOutputPanelTaxSavingsComponent implements OnInit {
    constructor(private readonly _reportManagerService: ReportManagerService) {}

    @Input() report: ReportDetail;
    outputFormatOptions: string[];
    paperSizeOptions: string[];
    valueOrderByOptions: ValueOrderByOption[];

    async ngOnInit() {
        const formatOutputOptions = new FormatOutputOptionsValue();
        _.assign(this, formatOutputOptions);

        const options = await this._reportManagerService.getValueOrderByOptions();
        this.valueOrderByOptions = _.sortBy(options, 'primarySortOrder');

        const defaultOrderBy =
            this.valueOrderByOptions.find((option) => option.id === siteNameOrderById) ?? this.valueOrderByOptions[0];

        this.report.criteria.outputFormat = this.report.criteria.outputFormat ?? 0;
        this.report.criteria.paperSize = this.report.criteria.paperSize ?? letterPaperSizeIndex;
        this.report.criteria.valueOrderBy = this.report.criteria.valueOrderBy || defaultOrderBy.id;
    }
}
